import { render, staticRenderFns } from "./BonusPointsRecord.vue?vue&type=template&id=4aefa0ac&scoped=true&"
import script from "./BonusPointsRecord.vue?vue&type=script&lang=js&"
export * from "./BonusPointsRecord.vue?vue&type=script&lang=js&"
import style0 from "./BonusPointsRecord.vue?vue&type=style&index=0&id=4aefa0ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aefa0ac",
  null
  
)

export default component.exports